interface FilterGroupProps {
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterGroup({ label, options, value, onChange }: FilterGroupProps) {
  const allOptions = ["全部", ...options];

  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 py-3 border-b border-background-200 last:border-b-0">
      <div className="w-16 shrink-0 text-sm font-medium text-foreground-500 pt-1.5">{label}</div>
      <div className="flex flex-wrap gap-2">
        {allOptions.map((option) => {
          const active = value === option || (option === "全部" && value === "");
          return (
            <button
              key={option}
              type="button"
              onClick={() => onChange(option === "全部" ? "" : option)}
              className={`px-3 py-1.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
                active
                  ? "bg-primary-600 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}